import { Grid } from "@mui/material";
import { Typography } from "@platform/design-system";

import TextInfo from "./textInfo";

const InfoGrid = ({
  title,
  value,
  tooltip = "",
  specialValue = null,
  centroCarrierSelected = false,
  ...gridProps
}) => (
  <Grid
    display="flex"
    gap={1}
    sx={{ wordWrap: "break-word" }}
    flexDirection="column"
    {...gridProps}
  >
    {tooltip ? (
      <TextInfo tootltipMsg={tooltip}>
        <Typography variant="body-large">
          <strong>{title}</strong>
        </Typography>
      </TextInfo>
    ) : (
      <Typography variant="body-large">
        <strong>{title}</strong>
      </Typography>
    )}
    {specialValue ?? (
      <Typography>
        {centroCarrierSelected ? <em>{value}</em> : value}
      </Typography>
    )}
  </Grid>
);

export default InfoGrid;
